<div class="responsive-wrapper" *ngIf="inModal" [ngClass]="{'in-modal': inModal, embed: embed, draft: (mediaclip && mediaclip.status === 'draft')}">
	<div class="wrapper">
		<h3 class="mobile">{{'EMBED' | translate}}</h3>

		<div class="player" *ngIf="isActive">
			<bb-player *ngIf="configuration.showVideo && (playlist || (mediaclip && ( mediaclip.mediatype === 'video' || mediaclip.mediatype === 'audio')))"
				[mediaclip]="mediaclip"
				[autoplay]="configuration?.autoPlay"
				[playoutOverrides]="{width: '100%', responsiveSizing: 'true', allowImageSequence:'false', fullScreen:'Hide'}"></bb-player>
		</div>
	</div>
</div>
<div class="vast-embeds">
	<div class="message warning" *ngIf="!mediaclip.transcodingFinished">
		{{ 'CREATIVE_ENCODING_NOT_YET_FINISHED_WARNING' | translate }}
	</div>
	<h3>{{ 'VAST_TAG' | translate }}:</h3>
	<div class="advanced-vast-tag-options" *ngIf="mediaclip && mediaclip.assets" style="width: 90%; position: relative;">
		<span class="advanced-text" (click)="settings.showVastAdvanced = !settings.showVastAdvanced" *ngIf="mediaclip && mediaclip.transcodingFinished" style="position: absolute; right: 0; top: -30px; padding: 3px; cursor: pointer;">
			<span class="arrow-right" [hidden]="settings.showVastAdvanced">&#9654;</span>
			<span class="arrow-down" [hidden]="!settings.showVastAdvanced">&#9660;</span>
			{{ 'ADVANCED' | translate }}
		</span>
		<div class="advanced-inner" [hidden]="!settings.showVastAdvanced">
			<strong>
				{{ 'ONLY_INCLUDE' | translate }}:
			</strong>
			<div *ngFor="let asset of mediaclip.assets" style="margin-bottom: 5px;" [hidden]="asset?.mediatype === 'MP4_TIMELINE'">
				<label class="label-after-checkbox" style="line-height: 32px; display: block;" *ngIf="asset?.jobdefid">
					<bb-check [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedAssetRef[asset.jobdefid]" (change)="assetSelectionChanged($event, asset.jobdefid)"></bb-check>
					<!-- <bb-checkbox style="margin: 0 5px;" ng-model="selectedAssetRef[asset.jobdefid]" ng-change="assetSelectionChanged($event, asset.jobdefid)" bb-checked="asset.mediatype !== 'MP4_TIMELINE'"></bb-checkbox> -->
					<span class="inner">
						{{ asset?.mediatype }}
						({{ asset?.height }}p, {{asset?.bandwidth}} kbps)
					</span>
				</label>
			</div>
		</div>
	</div>
	<input type="text" class="vast-tag-code" [value]="getVastUrl('vast')" readonly /><br />

	<a [href]="getVastPreviewUrl( getVastUrl('vast') )" target="_blank"
			class="button"><i class="fa fa-external-link"></i> {{ 'OPEN_IN_VAST_INSPECTOR' | translate }}</a>

	<button class="button" (click)="copyText(getVastUrl('vast'))"><i class="fa fa-copy"></i> {{ 'COPY_URL' | translate }}</button>

	<h3>{{ 'VPAID_TAG' | translate }}:</h3>
	
	<input type="text" class="vast-tag-code" [value]="getVastUrl('vpaid')" readonly /><br />
	
	<a [href]="getVastPreviewUrl( getVastUrl('vpaid') )" target="_blank"
			class="button"><i class="fa fa-external-link"></i> {{ 'OPEN_IN_VAST_INSPECTOR' | translate }}</a>

	<button class="button" (click)="copyText(getVastUrl('vpaid'))"><i class="fa fa-copy"></i> {{ 'COPY_URL' | translate }}</button>

	<h3>{{ 'SIMID_TAG' | translate }}:</h3>
	
	<input type="text" class="vast-tag-code" [value]="getVastUrl('simid')" readonly /><br />
	
	<a [href]="getVastPreviewUrl( getVastUrl('simid') )" target="_blank"
			class="button"><i class="fa fa-external-link"></i> {{ 'OPEN_IN_VAST_INSPECTOR' | translate }}</a>

	<button class="button" (click)="copyText(getVastUrl('simid'))"><i class="fa fa-copy"></i> {{ 'COPY_URL' | translate }}</button>
</div>
